import sensors from '@/utils/sensor';
import { trackParams, findTrackPageComment } from '@/index/enum';

const noop = () => {};

/**
 * 获取URL参数，不传key则返回所有
 * @param key
 * @returns
 */
const getUrlParam = (key?) => {
  const paramsString = window.location.href.split('?')[1];
  if (!paramsString) {
    return key ? '' : {};
  }

  const paramsArray = paramsString.split('&');
  const params = {};

  paramsArray.forEach((param) => {
    const [paramKey, paramValue] = param.split('=');
    params[paramKey] = paramValue || '';
  });

  if (key) {
    return params[key] || '';
  }

  return params;
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }

  return '';
};
/**
 * 移除小数点后面的0
 * @param {*} text
 */
function removeZero(text) {
  const arrs = text.split('.');
  if (arrs.length === 1) {
    return text;
  } else {
    const decimalsArr = arrs[1].split('');
    const newArr = [];
    let noZero = false;
    decimalsArr.reverse().forEach((e) => {
      if (noZero) {
        newArr.push(e);
      } else if (e !== '0') {
        newArr.push(e);
        noZero = true;
      }
    });

    return `${arrs[0]}${newArr.length === 0 ? '' : `.${newArr.reverse().join('')}`}`;
  }
}
/**
 * 把元每隔三位用，隔开
 * @param {*} text
 */
function splitYuan(text) {
  const splitArrs = [];
  const arrs = text.split('');
  const len = arrs.length;
  arrs.reverse().forEach((item, index) => {
    splitArrs.push(item);
    if (index % 3 === 2 && index !== len - 1) {
      splitArrs.push(',');
    }
  });
  return splitArrs.reverse().join('');
}
/**
 * 分转元 如果后两位为0则截掉
 * @param {*} text
 * @param {*} withUnit 前面是否带¥
 * @param {*} precision 最高精确度
 * @returns
 */
function fenToYuanFixed(text, withUnit = true, precision = 2) {
  let price = ((text || 0) / 100).toFixed(precision);

  const arrs = removeZero(price).split('.');
  if (arrs.length === 1) {
    // 没有分
    return `${withUnit ? '¥' : ''}${splitYuan(arrs[0])}`;
  } else if (arrs.length === 2) {
    // 有分
    return `${withUnit ? '¥' : ''}${splitYuan(arrs[0])}.${arrs[1]}`;
  }
}
// 版本号比较 https://developers.weixin.qq.com/miniprogram/dev/framework/compatibility.html#1.%20%E7%89%88%E6%9C%AC%E5%8F%B7%E6%AF%94%E8%BE%83
const compareVersion = (v1, v2) => {
  v1 = v1.split('.');
  v2 = v2.split('.');
  const len = Math.max(v1.length, v2.length);

  while (v1.length < len) {
    v1.push('0');
  }
  while (v2.length < len) {
    v2.push('0');
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i]);
    const num2 = parseInt(v2[i]);

    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }

  return 0;
};

const getEnv = () => {
  const hostConfig = {
    test: ['lego-h5-dev.wywk.cn', 'lego-h5-test.wywk.cn', 'hk-test.wanyoo.com'],
    uat: ['lego-h5-uat.wywk.cn'],
    prod: ['lego-h5.wywk.cn', 'hk.wanyoo.com'],
  };
  const host = document.domain.toLowerCase();
  let env = 'dev';

  if (hostConfig.test.includes(host)) {
    env = 'test';
  } else if (hostConfig.uat.includes(host)) {
    env = 'uat';
  } else if (hostConfig.prod.includes(host)) {
    env = 'prod';
  }
  console.log('env', env);
  return env;
};

const getApiUrl = () => {
  const apiUrlMap = {
    dev: 'https://vip-gateway-uat.wywk.cn',
    test: 'https://vip-gateway-uat.wywk.cn',
    uat: 'https://vip-gateway-uat.wywk.cn',
    prod: 'https://vip-gateway.wywk.cn',
  };

  return apiUrlMap[getEnv()];
};

const isOversea = () => {
  const parsedUrl = new URL(window.location.href);
  const domain = parsedUrl.hostname;
  return !domain.includes('.wywk.cn') && !domain.includes('localhost');
};

const getOpenInstallAppKey = () => {
  const appKeyMap = {
    dev: 'wq4gnz',
    test: 'wq4gnz',
    uat: 'wq4gnz',
    prod: 'o1lowj',
  };

  return appKeyMap[getEnv()];
};

/**
 * 距离格式化
 * @param distance
 * @returns
 */
const formatDistance = (distance = 0) => {
  if (distance < 1000) {
    return distance.toFixed(0) + 'm';
  } else {
    return (distance / 1000).toFixed(1) + 'km';
  }
};

/**
 * 埋点
 * @param params
 * @param type
 */
const commonTrack = (params, type, title) => {
  const pageCode = getUrlParam('code');

  sensors.track('LEGO_block_click', {
    page_title: trackParams.track_code,
    page_name: trackParams.page_name,
    page_comment: findTrackPageComment(type),
    product_name: title,
    product_type: 'SingleColImg',
    product_detail: params?.linkUrl,
    activity_code: pageCode,
    button_name: '单列图',
    banner_frame: params?.index,
  });
};

export {
  getUrlParam,
  getCookie,
  getEnv,
  getApiUrl,
  noop,
  getOpenInstallAppKey,
  compareVersion,
  fenToYuanFixed,
  formatDistance,
  commonTrack,
  isOversea,
};
